module.exports = __webpack_public_path__ + "static/007.thumb-f2cd0ef4f414dd753f46571f5c8196a8.jpg";